import React, { useState } from 'react'
import {
  FormsCol,
  TextBoxFormInput,
  OptionsPanel,
  ErrorNotice,
  QuestionPanel,
} from './TextBoxFormBuilder.styles'
import PropTypes, { InferProps } from 'prop-types'
import { isEmpty } from 'ramda'

type Answer = {
  questionKey: string
  answers: Array<string>
}

type ChangeEvent = React.ChangeEvent<HTMLTextAreaElement>

export interface BuilderLabel {
  id: string
  label: string
}

export interface BuilderInputs {
  name: string
  placeholder?: string
}

TextBoxFormBuilder.defaultProps = {
  builderValue: '',
  rows: 4,
  notice: undefined,
}

TextBoxFormBuilder.propTypes = {
  builderLabel: PropTypes.object as PropTypes.Validator<BuilderLabel>,
  builderInputs: PropTypes.object as PropTypes.Validator<BuilderInputs>,
  onInputChange: PropTypes.func as PropTypes.Validator<(answers: Answer) => void>,
  error: PropTypes.string as PropTypes.Validator<string | undefined>,
  rows: PropTypes.number as PropTypes.Validator<number | undefined>,
  builderValue: PropTypes.string as PropTypes.Validator<string>,
  notice: PropTypes.string as PropTypes.Requireable<string>,
}

function TextBoxFormBuilder({
  builderLabel,
  builderInputs,
  builderValue,
  onInputChange,
  error,
  rows,
  notice,
}: InferProps<typeof TextBoxFormBuilder.propTypes>) {
  const [textValue, setTextValue] = useState(builderValue || '')

  const handleInputsChange = (event: ChangeEvent) => {
    const { value } = event.target
    setTextValue(value)
    onInputChange({ questionKey: builderLabel?.id, answers: [value] })
  }
  return (
    <>
      <QuestionPanel>
        <label htmlFor={builderLabel?.id}>{builderLabel?.label}</label>
      </QuestionPanel>
      {/* {notice && <TextNotice>{notice}</TextNotice>} */}

      <OptionsPanel>
        <FormsCol>
          <TextBoxFormInput
            value={textValue}
            name={builderInputs?.name}
            placeholder={builderInputs?.placeholder || ''}
            onChange={handleInputsChange}
            rows={rows}
          />
          {error && !isEmpty(error) && <ErrorNotice>{error}</ErrorNotice>}
        </FormsCol>
      </OptionsPanel>
    </>
  )
}

export default TextBoxFormBuilder
